import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'src/makeStyles';
import { withTranslation } from '../src/i18n';
import { TP } from '../constants/consts';
import Layout, { LayoutContent } from '../components/Layout';
import ParseHtml from '../components/ParseHtml';
import route from '../constants/routes';
import { createSeoStringFromArray } from '../utils/seo';

const useStyles = makeStyles()({
  text: {
    '& p': {
      margin: 0,
    },
    '& h2': {
      fontSize: 18,
      fontFamily: 'Roboto',
    },
  },
});

const Privpol = ({ t }) => {
  const { classes } = useStyles();

  return (
    <Layout
      customBreadcrumbs={[
        { path: route.HOME, title: `${TP}.m_HOME` },
        { path: `${route.PRIVACY}/`, title: `${TP}.FN_PRIVPOL` },
      ]}
      title={t(`${TP}.FN_PRIVPOL`)}
      seo={{
        title: createSeoStringFromArray([t(`${TP}.FN_PRIVPOL`), t(`${TP}.m_OPERABASE`)]),
        ogTitle: createSeoStringFromArray([t(`${TP}.FN_PRIVPOL`), t(`${TP}.m_OPERABASE`)]),
        description: t(`${TP}.FN_PRIVPOL_DESC`),
      }}
    >
      <LayoutContent>
        <ParseHtml className={classes.text} lang="en">
          {t(`${TP}.FN_PRIVACY_POLICY`)}
        </ParseHtml>
      </LayoutContent>
    </Layout>
  );
};

Privpol.getInitialProps = async () => ({
  namespacesRequired: ['translation', 'privpol'],
});

Privpol.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('translation')(Privpol);
